import { render, staticRenderFns } from "./ApiTokens.vue?vue&type=template&id=13dc0fd3&scoped=true"
import script from "./ApiTokens.vue?vue&type=script&lang=ts"
export * from "./ApiTokens.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13dc0fd3",
  null
  
)

export default component.exports